module.exports = __webpack_public_path__ + "img/next-disabled.f15b27e3.svg";